import Model, { attr, belongsTo, hasMany, type AsyncHasMany, type AsyncBelongsTo } from '@ember-data/model';
import type AmenityModel from 'garaje/models/amenity';
import type FloorModel from 'garaje/models/floor';
import type ReservationModel from 'garaje/models/reservation';
import adapter from 'garaje/utils/decorators/adapter';
import RelationshipsTracker from 'garaje/utils/decorators/relationships-tracker';

import type DraftModel from './draft';
import type NeighborhoodModel from './neighborhood';

@RelationshipsTracker
@adapter('rms')
class DeskModel extends Model {
  // Attributes
  @attr('string') declare name: string;
  @attr('boolean') declare enabled: boolean;
  @attr('string') declare assignedTo: string;
  @attr('number') declare xPos: number;
  @attr('number') declare yPos: number;
  @attr('number') declare parentDeskId: number;

  // Relationships
  @belongsTo('floor') declare floor: FloorModel;
  @belongsTo('draft') declare draft: DraftModel;
  @belongsTo('neighborhood') declare neighborhood: AsyncBelongsTo<NeighborhoodModel>;
  @hasMany('reservation') declare reservations: AsyncHasMany<ReservationModel>;
  @hasMany('amenity') declare amenities: AsyncHasMany<AmenityModel>;

  get neighborhoodName(): string | null {
    const key = 'neighborhood' as Exclude<keyof this, keyof Model>;
    const neighborhood = this?.belongsTo(key)?.value() as NeighborhoodModel;

    return neighborhood?.name;
  }

  get placed(): boolean {
    return !!this.xPos && !!this.yPos;
  }
}

export default DeskModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    desk: DeskModel;
  }
}
